<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="filter.searchText" style="width: 260px"
                placeholder="单据编号、商品名、供应商"></el-input>
      <label style="margin-left: 12px; margin-right: 8px">内领仓库</label>
      <warehouse-select v-model="filter.warehouse" select-all></warehouse-select>
      <label style="margin-left: 12px; margin-right: 8px">内领日期</label>
      <el-date-picker
        style="width: 130px"
        v-model="filter.begDate"
        type="date"
        placeholder="开始日期">
      </el-date-picker>
      <el-date-picker
        style="margin-left: 8px; width: 130px"
        v-model="filter.endDate"
        type="date"
        placeholder="结束日期">
      </el-date-picker>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-button><a :href="exportUrl">导出</a></el-button>
    </div>
    <el-table :data="neilingList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head" :max-height="tableHeight">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="单据编号" prop="code" min-width="130"></el-table-column>
      <el-table-column label="内领日期" prop="outDate"></el-table-column>
      <el-table-column label="内领仓库">
        <template #default="{row}">
          <div>{{ row.warehouseId | valueName('Warehouse') }}
            - {{ row.warehousePosId | valueName('WarehousePos') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="内领商品" prop="goodsName"></el-table-column>
      <el-table-column label="商品类型" prop="goodsType"></el-table-column>
      <el-table-column label="数量" prop="goodsNum"></el-table-column>
      <el-table-column label="金额" prop="goodsPrice"></el-table-column>
      <el-table-column label="状态">
        <template #default="{row}">
          <div>{{ convertStatus(row.status) }}</div>
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 150 : 160" label="操作" align="center" fixed="right">
        <template #default="{row}">
          <el-button type="text" @click="detail(row)" size="mini">详情</el-button>
          <el-popconfirm v-if="canApprove && row.status===1"
                         @confirm="approve(row)" style="margin-left: 8px" title="是否审批通过？">
            <el-button type="text" size="mini" slot="reference">审批</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteNeiling(row)" class="danger" :disabled="row.status === 2">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import WarehouseSelect from '@/components/selector/WarehouseSelect'
import { valueName } from '@/utils/filters'
import authority from '@/utils/authority'
import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

export default {
  name: 'NeilingList',
  mixins: [resizeCaptureMixin],
  components: { WarehouseSelect },
  data () {
    return {
      loading: false,
      filter: {
        searchText: null,
        warehouse: [null],
        begDate: null,
        endDate: null
      }
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'SUPPLIER')
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$store.dispatch('neiling/all').finally(() => {
        this.loading = false
      })
    },
    add () {
      this.$router.push({
        path: '/product/neiling_goods'
      })
    },
    detail (neiling) {
      this.$router.push({
        path: '/product/neiling_goods',
        query: { neilingId: neiling.id }
      })
    },
    approve (item) {
      item.status = 2
      this.$store.dispatch('neiling/updateOne', item).then(() => {
        this.$message.success('审批通过!')
      })
    },
    deleteNeiling (neiling) {
      this.$confirm(`确认删除内领【${neiling.code}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('neiling/delete', neiling.id).then(() => {
          this.$message.success('删除成功!')
        })
      }).catch(() => {
      })
    },
    convertStatus (status) {
      switch (status) {
        case 0:
          return '已保存'
        case 1:
          return '未审批'
        case 2:
          return '审批通过'
      }
      return status
    }
  },
  computed: {
    neilingList () {
      let list = this.$store.state.neiling.neilingList

      if (this.filter.searchText) {
        list = list.filter(neiling => {
          if (neiling.code && neiling.code.indexOf(this.filter.searchText) !== -1) return true
          for (const goods of neiling.goodsList) {
            if (goods.name && goods.name.indexOf(this.filter.searchText) !== -1) return true
            if (goods.supplierCode &&
              valueName(goods.supplierCode, 'SUPPLIER').indexOf(this.filter.searchText) !== -1) return true
          }
          return false
        })
      }

      if (this.filter.warehouse[0]) {
        list = list.filter(neiling => {
          return neiling.warehouseId === this.filter.warehouse[0] && neiling.warehousePosId === this.filter.warehouse[1]
        })
      }

      if (this.filter.begDate !== null) {
        list = list.filter(neiling => {
          return this.filter.begDate.format('yyyy-MM-dd') <= neiling.outDate
        })
      }

      if (this.filter.endDate !== null) {
        list = list.filter(neiling => {
          return this.filter.endDate.format('yyyy-MM-dd') >= neiling.outDate
        })
      }

      return list
    },
    tableHeight () {
      return this.clientHeight - 224
    },
    readOnly () {
      return !this.$hasPermission(authority.NEILING)
    },
    addable () {
      return this.$hasPermission(authority.NEILING)
    },
    deletable () {
      return this.$hasPermission(authority.NEILING)
    },
    canApprove () {
      return this.$hasPermission(authority.NEILING_SHENHE)
    },
    exportUrl () {
      const filter = this.$_.cloneDeep(this.filter)
      if (filter.begDate) {
        filter.begDate = filter.begDate.formatDate()
      }
      if (filter.endDate) {
        filter.endDate = filter.endDate.formatDate()
      }

      return this.$baseUrl + 'api/downloadNeilingList?filterStr=' + encodeURIComponent(JSON.stringify(filter))
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}

label {
  margin-right: 10px;
  font-size: 13px;
  color: #646464;
}
</style>
